export class ExtendedSearchParams extends URLSearchParams {
  toObject(): Record<string, string | string[]> {
    const result: Record<string, string | string[]> = {};
    const keys = Array.from(new Set(Array.from(this.keys())));

    keys.forEach((key) => {
      const all = this.getAll(key);
      if (all.length > 1) {
        result[key] = all;
      } else if (all.length === 1) {
        result[key] = all[0];
      }
    });

    return result;
  }
}
